module.exports = __webpack_public_path__ + "img/pc_banner_cookie.5441052a.jpeg";